import { FC, ReactElement } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import {Navigate} from 'react-router-dom';

interface ProtectedProps {
   redirectTo?: string,
   component: ReactElement
}

export const Protected: FC<ProtectedProps> = ({
   redirectTo = '/',
   component
}) => {
   const { keycloak } = useKeycloak();

   const loggedIn = keycloak.authenticated;

   if (!loggedIn) {
      keycloak.login();
      return <></>;
   }

   if (!component) {
      return <Navigate to={redirectTo} replace />;
   }

   return <>{component}</>;
};
